import React from "react";
import { Zap, Wifi, WifiOff, Settings as SettingsIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function TopBar({ updatedLabel, mysqlConnected, meterName }) {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/[0.03] border-b border-white/10">
      <div className="max-w-[1600px] mx-auto px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="w-8 h-8 border border-white/20 flex items-center justify-center">
            <Zap className="w-4 h-4" strokeWidth={1.5} />
          </div>
          <div>
            <div className="font-heading font-bold text-sm tracking-wide">ENERGY.OPS</div>
            <div className="label-tech text-[9px]">{meterName || "METER"} · 3-PHASE</div>
          </div>
        </div>

        <div className="hidden md:flex items-center gap-6">
          <div className="flex items-center gap-2">
            <div className="dot-live" />
            <span className="label-tech">LIVE · {updatedLabel}</span>
          </div>
          <div className="flex items-center gap-2 label-tech">
            {mysqlConnected ? (
              <><Wifi className="w-3 h-3 text-emerald-400" /> MYSQL</>
            ) : (
              <><WifiOff className="w-3 h-3 text-yellow-400" /> OFFLINE</>
            )}
          </div>
        </div>

        <div className="flex items-center gap-3">
          <Button
            data-testid="settings-btn"
            onClick={() => navigate("/settings")}
            variant="outline"
            className="border-white/15 bg-transparent text-white hover:bg-white/10 rounded-sm h-8 px-3"
            title="Settings (admin only)"
          >
            <SettingsIcon className="w-3 h-3 mr-2" /> SETTINGS
          </Button>
        </div>
      </div>
    </header>
  );
}
